import { BaseButton } from "iebt-zing-storybook";
import React from "react";
import {
  LikertScaleAnswer,
  LikertScaleRange,
  LikertScaleWrapper,
} from "./styles";
import { trans } from "sharedKernel/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";
import { followCursor } from "tippy.js";
import { Button } from "react-bootstrap";

interface LikertScaleProps {
  range: number;
  answer: number | null;
  question: string;
  description: string;
  gradeInfo?: string;
  order: number;
  onChange: (value: number | null) => void;
  onClick: (value: number | null) => void;
}

export const LikertScale = ({
  range,
  answer,
  question,
  description,
  order,
  gradeInfo,
  onChange: handleChange,
  onClick: handleClick,
}: LikertScaleProps): JSX.Element => {
  const GradeInfoContent = (): JSX.Element => (
    <div
      style={{
        whiteSpace: "pre-wrap",
        maxWidth: "300px",
        wordBreak: "break-word",
      }}
    >
      {gradeInfo}
    </div>
  );
  return (
    <LikertScaleWrapper>
      {`${order + 1}. ${question}`}
      {description !== "" ? (
        <Tippy
          content={description}
          placement="right"
          followCursor={true}
          plugins={[followCursor]}
          animation="scale"
          arrow={false}
          theme="primary"
        >
          <span>
            <FontAwesomeIcon icon={["fas", "circle-info"]} className="ml-2" />
          </span>
        </Tippy>
      ) : (
        <></>
      )}

      {gradeInfo !== null && gradeInfo !== "" ? (
        <Tippy
          content={<GradeInfoContent />}
          placement="left"
          followCursor={true}
          plugins={[followCursor]}
          animation="scale"
          arrow={false}
          theme="primary"
        >
          <span>
            <FontAwesomeIcon
              icon={["fas", "circle-question"]}
              style={{ marginLeft: "0.2rem" }}
            />
          </span>
        </Tippy>
      ) : (
        <></>
      )}
      <LikertScaleAnswer>
        <LikertScaleRange>
          {range > 1
            ? [...Array(range + 1).keys()].map((value) => {
                const radioId = `radio-${order}-${value}`;
                const isSelected = answer === value;
                return (
                  <label
                    key={`likertScaleOption.${value}`}
                    htmlFor={radioId}
                    onClick={(e) => {
                      if (isSelected) {
                        e.preventDefault();
                        handleChange(null);
                        handleClick(null);
                      }
                    }}
                  >
                    <input
                      type="radio"
                      id={radioId}
                      name={`question-${order}`}
                      value={value}
                      checked={isSelected}
                      onChange={(e) => {
                        const newValue = parseInt(e.target.value);
                        handleChange(newValue);
                        handleClick(newValue);
                      }}
                    />
                    <span className="radio-label">{value}</span>
                  </label>
                );
              })
            : [...Array(2).keys()].map((index) => {
                const texts = ["Sim", "Não"];
                const values = [1, 0];
                const value = values[index];
                const radioId = `radio-${order}-${value}`;
                const isSelected = answer === value;
                return (
                  <label
                    key={`likertScaleOption.${value}`}
                    htmlFor={radioId}
                    onClick={(e) => {
                      if (isSelected) {
                        e.preventDefault();
                        handleChange(null);
                        handleClick(null);
                      }
                    }}
                  >
                    <input
                      type="radio"
                      id={radioId}
                      name={`question-${order}`}
                      value={value}
                      checked={isSelected}
                      onChange={(e) => {
                        const newValue = parseInt(e.target.value);
                        handleChange(newValue);
                        handleClick(newValue);
                      }}
                    />
                    <span className="radio-label">{texts[index]}</span>
                  </label>
                );
              })}

          <button
            className="clear-button clear-icon"
            onClick={(e) => {
              const newValue = null;
              handleChange(newValue);
              handleClick(newValue);
            }}
            title="Limpar"
          >
            <FontAwesomeIcon
              className="clear-icon"
              icon={["fas", "eraser"]}
              size="lg"
            />
          </button>
        </LikertScaleRange>
      </LikertScaleAnswer>
    </LikertScaleWrapper>
  );
};
